@if (sessionService.is_admin()) {
<button
  @fadeInAnimation
  class="trivia"
  (click)="modalService.openModal('TriviaRegularModal')"
>
  Trivia
</button>
<button
  @fadeInAnimation
  class="trivia-rain"
  (click)="modalService.openModal('TriviaRainModal')"
>
  Trivia Rain
</button>
}
